// extracted by mini-css-extract-plugin
export var errorIcon = "_k3-1";
export var nameLogo = "_k3-0";